import {
  hasPaywallWebViewBridge,
  hasPaywallWebViewUserAgent,
} from '@/utils/webViewAccess';
import { ROUTES } from '@/constants/routes';

export function isBrowserSessionEnvironment(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    window.parent === window
    && !hasPaywallWebViewBridge(window)
    && !hasPaywallWebViewUserAgent()
  );
}

export function readBrowserSessionCode(): string | null {
  if (
    !isBrowserSessionEnvironment()
    || window.location.pathname !== ROUTES.PAYWALL.V2
    || !window.location.hash
  ) {
    return null;
  }

  const params = new URLSearchParams(window.location.hash.slice(1));
  return params.get('session')?.trim() || null;
}
